import React, {
    useEffect,
    useState,
} from "react";

import {
    useDispatch,
    useSelector,
} from "react-redux";

import {
    fetchTenantProfile,

    updateTenantBusinessProfile,

    selectTenant,

    selectIsTenantOwner,

    selectTenantProfileLoading,

    selectTenantProfileError,

    selectTenantBusinessUpdating,

    selectTenantBusinessUpdateError,

    selectTenantBusinessUpdateSuccess,
} from "../../../../../store/tenantProfile/tenantProfileSlice";


const BusinessSettings =
    () => {

        const dispatch =
            useDispatch();


        /*
        |--------------------------------------------------------------------------
        | REDUX
        |--------------------------------------------------------------------------
        */

        const tenant =
            useSelector(
                selectTenant
            );


        const isOwner =
            useSelector(
                selectIsTenantOwner
            );


        const loading =
            useSelector(
                selectTenantProfileLoading
            );


        const error =
            useSelector(
                selectTenantProfileError
            );


        const updating =
            useSelector(
                selectTenantBusinessUpdating
            );


        const updateError =
            useSelector(
                selectTenantBusinessUpdateError
            );


        const updateSuccess =
            useSelector(
                selectTenantBusinessUpdateSuccess
            );


        /*
        |--------------------------------------------------------------------------
        | FORM
        |--------------------------------------------------------------------------
        */

        const [
            form,
            setForm,
        ] =
            useState({

                name:
                    "",

                legalName:
                    "",

                mobile:
                    "",

                email:
                    "",

                gstNumber:
                    "",

                panNumber:
                    "",

                address: {

                    line1:
                        "",

                    line2:
                        "",

                    city:
                        "",

                    state:
                        "",

                    country:
                        "India",

                    postalCode:
                        "",

                },

            });


        /*
        |--------------------------------------------------------------------------
        | LOAD
        |--------------------------------------------------------------------------
        */

        useEffect(
            () => {

                if (
                    !tenant
                ) {

                    dispatch(
                        fetchTenantProfile()
                    );

                }

            },
            [
                dispatch,
                tenant,
            ]
        );


        /*
        |--------------------------------------------------------------------------
        | SYNC TENANT
        |--------------------------------------------------------------------------
        */

        useEffect(
            () => {

                if (
                    !tenant
                ) {

                    return;

                }


                setForm({

                    name:
                        tenant.name ||
                        "",

                    legalName:
                        tenant.legalName ||
                        "",

                    mobile:
                        tenant.mobile ||
                        "",

                    email:
                        tenant.email ||
                        "",

                    gstNumber:
                        tenant.gstNumber ||
                        "",

                    panNumber:
                        tenant.panNumber ||
                        "",

                    address: {

                        line1:
                            tenant
                                ?.address
                                ?.line1 ||
                            "",

                        line2:
                            tenant
                                ?.address
                                ?.line2 ||
                            "",

                        city:
                            tenant
                                ?.address
                                ?.city ||
                            "",

                        state:
                            tenant
                                ?.address
                                ?.state ||
                            "",

                        country:
                            tenant
                                ?.address
                                ?.country ||
                            "India",

                        postalCode:
                            tenant
                                ?.address
                                ?.postalCode ||
                            "",

                    },

                });

            },
            [
                tenant,
            ]
        );


        /*
        |--------------------------------------------------------------------------
        | CHANGE NORMAL FIELD
        |--------------------------------------------------------------------------
        */

        const handleChange =
            (
                event
            ) => {

                const {
                    name,
                    value,
                } =
                    event.target;


                setForm(
                    (
                        previous
                    ) => ({

                        ...previous,

                        [name]:
                            value,

                    })
                );

            };


        /*
        |--------------------------------------------------------------------------
        | ADDRESS CHANGE
        |--------------------------------------------------------------------------
        */

        const handleAddressChange =
            (
                event
            ) => {

                const {
                    name,
                    value,
                } =
                    event.target;


                setForm(
                    (
                        previous
                    ) => ({

                        ...previous,

                        address: {

                            ...previous.address,

                            [name]:
                                value,

                        },

                    })
                );

            };


        /*
        |--------------------------------------------------------------------------
        | SAVE
        |--------------------------------------------------------------------------
        */

        const handleSubmit =
            async (
                event
            ) => {

                event.preventDefault();


                if (
                    !isOwner
                ) {

                    return;

                }


                const result =
                    await dispatch(
                        updateTenantBusinessProfile(
                            form
                        )
                    );


                if (
                    updateTenantBusinessProfile
                        .fulfilled
                        .match(
                            result
                        )
                ) {

                    await dispatch(
                        fetchTenantProfile()
                    );

                }

            };


        /*
        |--------------------------------------------------------------------------
        | LOADING
        |--------------------------------------------------------------------------
        */

        if (
            loading &&
            !tenant
        ) {

            return (

                <div className="settings-loading">

                    Loading business details...

                </div>

            );

        }


        return (

            <form
                onSubmit={
                    handleSubmit
                }
            >

                {/* ============================================================
                    HEADER
                ============================================================ */}

                <div className="settings-section-header">

                    <div>

                        <h2>
                            Business Details
                        </h2>

                        <p>
                            Manage your registered business information.
                        </p>

                    </div>

                </div>


                {/* ============================================================
                    OWNER WARNING
                ============================================================ */}

                {
                    !isOwner &&
                    (
                        <div className="settings-warning">

                            Only the business owner can update business details.

                        </div>
                    )
                }


                {/* ============================================================
                    LOAD ERROR
                ============================================================ */}

                {
                    error &&
                    (
                        <div className="settings-error">

                            {
                                error?.message ||
                                "Unable to load business details."
                            }

                        </div>
                    )
                }


                {/* ============================================================
                    UPDATE SUCCESS
                ============================================================ */}

                {
                    updateSuccess &&
                    (
                        <div className="settings-success">

                            Business details updated successfully.

                        </div>
                    )
                }


                {/* ============================================================
                    UPDATE ERROR
                ============================================================ */}

                {
                    updateError &&
                    (
                        <div className="settings-error">

                            {
                                updateError?.message ||
                                "Unable to update business details."
                            }

                        </div>
                    )
                }


                {/* ============================================================
                    SYSTEM DETAILS
                ============================================================ */}

                <div className="settings-business-summary">

                    <div>

                        <span>
                            Business Code
                        </span>

                        <strong>

                            {
                                tenant?.code ||
                                "-"
                            }

                        </strong>

                    </div>


                    <div>

                        <span>
                            Subdomain
                        </span>

                        <strong>

                            {
                                tenant?.subdomain ||
                                "-"
                            }

                        </strong>

                    </div>


                    <div>

                        <span>
                            Status
                        </span>

                        <strong>

                            {
                                tenant?.status ||
                                "-"
                            }

                        </strong>

                    </div>

                </div>


                {/* ============================================================
                    BUSINESS INFORMATION
                ============================================================ */}

                <div className="settings-form-grid">

                    <div className="settings-field">

                        <label>
                            Business Name
                        </label>

                        <input
                            type="text"

                            name="name"

                            value={
                                form.name
                            }

                            onChange={
                                handleChange
                            }

                            disabled={
                                !isOwner
                            }
                        />

                    </div>


                    <div className="settings-field">

                        <label>
                            Legal Name
                        </label>

                        <input
                            type="text"

                            name="legalName"

                            value={
                                form.legalName
                            }

                            onChange={
                                handleChange
                            }

                            disabled={
                                !isOwner
                            }
                        />

                    </div>


                    <div className="settings-field">

                        <label>
                            Business Mobile
                        </label>

                        <input
                            type="text"

                            name="mobile"

                            value={
                                form.mobile
                            }

                            onChange={
                                handleChange
                            }

                            disabled={
                                !isOwner
                            }
                        />

                    </div>


                    <div className="settings-field">

                        <label>
                            Business Email
                        </label>

                        <input
                            type="email"

                            name="email"

                            value={
                                form.email
                            }

                            onChange={
                                handleChange
                            }

                            disabled={
                                !isOwner
                            }
                        />

                    </div>


                    <div className="settings-field">

                        <label>
                            GST Number
                        </label>

                        <input
                            type="text"

                            name="gstNumber"

                            value={
                                form.gstNumber
                            }

                            onChange={
                                handleChange
                            }

                            disabled={
                                !isOwner
                            }
                        />

                    </div>


                    <div className="settings-field">

                        <label>
                            PAN Number
                        </label>

                        <input
                            type="text"

                            name="panNumber"

                            value={
                                form.panNumber
                            }

                            onChange={
                                handleChange
                            }

                            disabled={
                                !isOwner
                            }
                        />

                    </div>

                </div>


                {/* ============================================================
                    ADDRESS
                ============================================================ */}

                <div className="settings-subsection">

                    <h3>
                        Business Address
                    </h3>


                    <div className="settings-form-grid">

                        <div className="settings-field">

                            <label>
                                Address Line 1
                            </label>

                            <input
                                type="text"

                                name="line1"

                                value={
                                    form.address.line1
                                }

                                onChange={
                                    handleAddressChange
                                }

                                disabled={
                                    !isOwner
                                }
                            />

                        </div>


                        <div className="settings-field">

                            <label>
                                Address Line 2
                            </label>

                            <input
                                type="text"

                                name="line2"

                                value={
                                    form.address.line2
                                }

                                onChange={
                                    handleAddressChange
                                }

                                disabled={
                                    !isOwner
                                }
                            />

                        </div>


                        <div className="settings-field">

                            <label>
                                City
                            </label>

                            <input
                                type="text"

                                name="city"

                                value={
                                    form.address.city
                                }

                                onChange={
                                    handleAddressChange
                                }

                                disabled={
                                    !isOwner
                                }
                            />

                        </div>


                        <div className="settings-field">

                            <label>
                                State
                            </label>

                            <input
                                type="text"

                                name="state"

                                value={
                                    form.address.state
                                }

                                onChange={
                                    handleAddressChange
                                }

                                disabled={
                                    !isOwner
                                }
                            />

                        </div>


                        <div className="settings-field">

                            <label>
                                Country
                            </label>

                            <input
                                type="text"

                                name="country"

                                value={
                                    form.address.country
                                }

                                onChange={
                                    handleAddressChange
                                }

                                disabled={
                                    !isOwner
                                }
                            />

                        </div>


                        <div className="settings-field">

                            <label>
                                Postal Code
                            </label>

                            <input
                                type="text"

                                name="postalCode"

                                value={
                                    form.address.postalCode
                                }

                                onChange={
                                    handleAddressChange
                                }

                                disabled={
                                    !isOwner
                                }
                            />

                        </div>

                    </div>

                </div>


                {/* ============================================================
                    PROTECTED SYSTEM VALUES
                ============================================================ */}

                <div className="settings-subsection">

                    <h3>
                        System Information
                    </h3>


                    <div className="settings-form-grid">

                        <div className="settings-field">

                            <label>
                                Business Code
                            </label>

                            <input
                                type="text"

                                value={
                                    tenant?.code ||
                                    ""
                                }

                                disabled
                            />

                        </div>


                        <div className="settings-field">

                            <label>
                                Subdomain
                            </label>

                            <input
                                type="text"

                                value={
                                    tenant?.subdomain ||
                                    ""
                                }

                                disabled
                            />

                        </div>


                        <div className="settings-field">

                            <label>
                                Custom Domain
                            </label>

                            <input
                                type="text"

                                value={
                                    tenant?.customDomain ||
                                    ""
                                }

                                disabled
                            />

                        </div>


                        <div className="settings-field">

                            <label>
                                Subscription Status
                            </label>

                            <input
                                type="text"

                                value={
                                    tenant?.subscriptionStatus ||
                                    ""
                                }

                                disabled
                            />

                        </div>

                    </div>

                </div>


                {/* ============================================================
                    ACTION
                ============================================================ */}

                {
                    isOwner &&
                    (
                        <div className="settings-actions">

                            <button
                                type="submit"

                                className="settings-save-button"

                                disabled={
                                    updating
                                }
                            >

                                {
                                    updating
                                        ?
                                        "Saving..."
                                        :
                                        "Save Business Details"
                                }

                            </button>

                        </div>
                    )
                }

            </form>

        );

    };


export default BusinessSettings;